import { motion, AnimatePresence } from 'framer-motion'
import { ShieldCheckIcon } from '@heroicons/react/24/solid'
import { Link } from 'react-router-dom'
import { useCookieConsent } from '@/context/CookieConsentContext'

export default function CookieConsentBanner() {
  const { consent, acceptCookies, declineCookies } = useCookieConsent()

  // Only show if the user hasn't made a choice yet
  const show = consent === null

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed bottom-0 left-0 right-0 z-[90] p-4"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
        >
          <div className="glass-panel max-w-3xl mx-auto px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Icon + text */}
            <div className="flex items-start gap-3 flex-1">
              <ShieldCheckIcon
                className="w-5 h-5 text-[var(--gold)] shrink-0 mt-0.5"
                aria-hidden="true"
              />
              <p className="text-[var(--text-muted)] text-xs leading-relaxed">
                We&apos;d like to record anonymized screen-replay sessions so we can debug UX
                friction and improve Illuminate.{' '}
                <strong className="text-[var(--text-primary)]">
                  Your conversations stay masked in replays. We never sell your data.
                </strong>{' '}
                <Link to="/privacy" className="text-[var(--gold)] hover:underline">
                  Privacy Policy
                </Link>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
              <motion.button
                onClick={acceptCookies}
                className="flex-1 sm:flex-none bg-[var(--gold)] text-[var(--text-on-gold)] font-bold text-xs px-4 py-2 rounded-lg"
                whileHover={{ y: -1, boxShadow: '0 4px 16px var(--glow-color)' }}
                whileTap={{ scale: 0.97 }}
              >
                Accept
              </motion.button>
              <button
                onClick={declineCookies}
                className="flex-1 sm:flex-none border border-[var(--glass-border)] text-[var(--text-muted)] hover:text-[var(--text-primary)] text-xs px-4 py-2 rounded-lg transition-colors duration-200"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
